exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leftPanel {\n  width: 200px;\n  display: inline-block;\n  text-align: center;\n  height: 100%;\n  vertical-align: top; }\n\n.rightPanel {\n  display: inline-block;\n  max-width: 1200px; }\n\n.photo {\n  border: 2px ridge blue;\n  border-radius: 3px;\n  max-width: 180px;\n  margin-top: 15px; }\n\n.leftPanel span {\n  font-weight: bolder; }\n\n.linkedIn {\n  text-decoration: none;\n  text-align: center; }\n\n.linkedInLogo {\n  display: block;\n  margin: 0 auto;\n  margin-top: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/thunder/git/portfolier/src/app/home/home.scss
// module id = ../../../../../src/app/home/home.scss
// module chunks = 1